// Grade conversion data is loaded at runtime from public/data/grades.json so
// the ~125KB lookup table is not baked into the JS bundle.
//
// Browser: call loadGrades(url) once during bootstrap before rendering.
// Node scripts: read the JSON from disk and pass it to setGradeData().

let gradeConversionData = null;

export const setGradeData = (data) => {
  gradeConversionData = data;
};

export const loadGrades = async (url) => {
  if (gradeConversionData) return gradeConversionData;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load grade data from ${url}: ${response.status}`);
  }
  gradeConversionData = await response.json();
  return gradeConversionData;
};

const requireData = () => {
  if (!gradeConversionData) {
    throw new Error('Grade conversion data not loaded. Call loadGrades() or setGradeData() during app bootstrap.');
  }
  return gradeConversionData;
};

export const findGradeByFrench = (frenchGrade) =>
  requireData().filter(row => row["french.sport"] === frenchGrade);

export const findGradeByUIAA = (uiaaGrade) =>
  requireData().filter(row => row.uiaa === uiaaGrade);

export const findGradeByYDS = (ydsGrade) =>
  requireData().filter(row => row.yds === ydsGrade);

// Binary search to find the closest matching grade row by ewbank.decimal.
const findClosestGrade = (ewbankDecimal) => {
  const data = requireData();
  let left = 0;
  let right = data.length - 1;

  if (ewbankDecimal <= data[0]['ewbank.decimal']) return data[0];
  if (ewbankDecimal >= data[right]['ewbank.decimal']) return data[right];

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const midValue = data[mid]['ewbank.decimal'];

    if (midValue === ewbankDecimal) return data[mid];

    if (right - left <= 1) {
      const leftDiff = Math.abs(data[left]['ewbank.decimal'] - ewbankDecimal);
      const rightDiff = Math.abs(data[right]['ewbank.decimal'] - ewbankDecimal);
      return leftDiff <= rightDiff ? data[left] : data[right];
    }

    if (midValue < ewbankDecimal) {
      left = mid;
    } else {
      right = mid;
    }
  }

  return data[left];
};

export const convertDecimalEwbanksToFrench = (ewbankDecimal) => {
  if (!ewbankDecimal || isNaN(ewbankDecimal)) return 'N/A';
  return findClosestGrade(ewbankDecimal)['french.sport'];
};

export const convertDecimalEwbanksToYDS = (ewbankDecimal) => {
  if (!ewbankDecimal || isNaN(ewbankDecimal)) return 'N/A';
  return findClosestGrade(ewbankDecimal)['yds'];
};
